module.exports = __webpack_public_path__ + "static/images/warning-circle-yellow.2oxbQ-l.svg";